import {Type} from '@angular/core';
import {ITableColumn} from './table-column';
import {ITableDataItem} from './table-data-item';


export interface ITableCellProperties {
    // eslint-disable-next-line
    [inputName: string]: any;
}

export interface ITableCellItem extends ITableCellProperties {
    dataItem: ITableDataItem,
    columnOptions: ITableColumn
}

export class TableCell<T = ITableCellItem> {

    constructor(public component: Type<ITableCellItem>, public properties: T) {
    }
}
